var S = Object.defineProperty, V = Object.defineProperties;
var w = Object.getOwnPropertyDescriptors;
var l = Object.getOwnPropertySymbols;
var T = Object.prototype.hasOwnProperty, g = Object.prototype.propertyIsEnumerable;
var b = (e, r, o) => r in e ? S(e, r, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[r] = o, p = (e, r) => {
  for (var o in r || (r = {}))
    T.call(r, o) && b(e, o, r[o]);
  if (l)
    for (var o of l(r))
      g.call(r, o) && b(e, o, r[o]);
  return e;
}, i = (e, r) => V(e, w(r));
var x = (e, r) => {
  var o = {};
  for (var s in e)
    T.call(e, s) && r.indexOf(s) < 0 && (o[s] = e[s]);
  if (e != null && l)
    for (var s of l(e))
      r.indexOf(s) < 0 && g.call(e, s) && (o[s] = e[s]);
  return o;
};
import { jsxs as a, jsx as m } from "react/jsx-runtime";
import n from "../../../node_modules/prop-types/index.es.js";
import { forwardRef as B } from "react";
import * as N from "./style.es.js";
import { Helper as O, HelperBody as P, HelperText as R, HelperCounter as $ } from "./style.es.js";
import { Icon as u } from "../Icon/Icon.es.js";
const f = B((k, j) => {
  var d = k, {
    counter: e,
    error: r,
    icon: o,
    lineClamp: s = 1,
    maxLength: c,
    showCounter: z,
    success: h,
    text: t
  } = d, C = x(d, [
    "counter",
    "error",
    "icon",
    "lineClamp",
    "maxLength",
    "showCounter",
    "success",
    "text"
  ]);
  const y = !!t, H = !!z && !!(typeof e == "number" && e >= 0 && c);
  if (!(y || H))
    return null;
  const I = () => r ? /* @__PURE__ */ m(u, { name: "error", size: "sm" }) : h ? /* @__PURE__ */ m(u, { name: "success", size: "sm" }) : o ? /* @__PURE__ */ m(u, p({ size: "sm" }, o)) : null;
  return /* @__PURE__ */ a(O, i(p({ ref: j, error: r, success: h }, C), { children: [
    y && /* @__PURE__ */ a(P, { children: [
      I(),
      /* @__PURE__ */ m(R, i(p({ lineClamp: s }, typeof t == "string" && {
        title: t
      }), { children: t }))
    ] }),
    H && /* @__PURE__ */ a($, { children: [
      e,
      " / ",
      c,
      " characters"
    ] })
  ] }));
});
f.S = N;
f.displayName = "Helper";
f.propTypes = {
  counter: n.number,
  error: n.bool,
  maxLength: n.number,
  lineClamp: n.number,
  success: n.bool,
  text: n.oneOfType([n.string, n.node])
};
export {
  f as Helper
};
//# sourceMappingURL=Helper.es.js.map
